import React from 'react';
import { Box, Container, Grid, Link, Typography } from '@material-ui/core';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import InstagramIcon from '@material-ui/icons/Instagram';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import SRI from './images/SRI.jpg';

export default function ModernFooter(props) {
  const {
    history,
    isMobile = false,
    onServicesClick,
    onHowItWorksClick,
    onPrivacyPolicy,
    onTermsConditions,
    onRefundPolicy,
  } = props;

  const goContact = (e) => {
    e.preventDefault();
    if (history) history.push('/contact');
  };
  const goHome = (e) => {
    e.preventDefault();
    if (history) history.push('/home');
  };
  const defaultPrivacy = () => history && history.push('/privacypolicy');
  const defaultTerms = () => history && history.push('/termsconditions');
  const defaultRefund = () => history && history.push('/refundpolicy');

  return (
    <Box style={{ backgroundColor: '#0D3B66', color: 'white', padding: isMobile ? '40px 0 20px' : '60px 0 20px' }}>
      <Container>
        <Grid container spacing={isMobile ? 2 : 4}>
          <Grid item xs={12} md={4}>
            <Box style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
              <img src={SRI} alt="SRIQR Logo" style={{ height: '50px', width: '50px', marginRight: '10px' }} />
              <Typography variant="h6" style={{ color: 'white', fontWeight: 'bold' }}>
                SRIQR.COM
              </Typography>
            </Box>
            <Typography variant="body2" style={{ color: 'rgba(255,255,255,0.8)', marginBottom: '20px' }}>
              The fastest way to book tickets and skip the queue. Secure, instant, and contactless.
            </Typography>
            <Box style={{ display: 'flex', gap: '15px' }}>
              <FacebookIcon style={{ color: 'white', cursor: 'pointer' }} />
              <TwitterIcon style={{ color: 'white', cursor: 'pointer' }} />
              <InstagramIcon style={{ color: 'white', cursor: 'pointer' }} />
              <LinkedInIcon style={{ color: 'white', cursor: 'pointer' }} />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Typography
              variant="h6"
              style={{
                color: 'white',
                marginBottom: '20px',
                fontFamily: '"DM Sans", sans-serif',
                fontWeight: 'bold',
                fontSize: isMobile ? '16px' : '18px',
                textAlign: isMobile ? 'center' : 'left',
              }}
            >
              Services
            </Typography>
            <Box
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                alignItems: isMobile ? 'center' : 'flex-start',
              }}
            >
              <Link href="javascript:void(0)" onClick={onServicesClick || goHome} style={{ color: 'rgba(255,255,255,0.8)', textDecoration: 'none' }}>
                Park Tickets
              </Link>
              <Link href="javascript:void(0)" onClick={onServicesClick || goHome} style={{ color: 'rgba(255,255,255,0.8)', textDecoration: 'none' }}>
                Bank Tokens
              </Link>
              <Link href="javascript:void(0)" onClick={onServicesClick || goHome} style={{ color: 'rgba(255,255,255,0.8)', textDecoration: 'none' }}>
                Doctor Appointments
              </Link>
              <Link href="javascript:void(0)" onClick={onServicesClick || goHome} style={{ color: 'rgba(255,255,255,0.8)', textDecoration: 'none' }}>
                Event Tickets
              </Link>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              variant="h6"
              style={{
                color: 'white',
                marginBottom: '20px',
                fontFamily: '"DM Sans", sans-serif',
                fontWeight: 'bold',
                fontSize: isMobile ? '16px' : '18px',
                textAlign: isMobile ? 'center' : 'left',
              }}
            >
              Company
            </Typography>
            <Box
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                alignItems: isMobile ? 'center' : 'flex-start',
              }}
            >
              <Link href="#about" onClick={onServicesClick || goHome} style={{ color: 'rgba(255,255,255,0.8)', textDecoration: 'none', fontSize: isMobile ? '13px' : '14px' }}>
                Services
              </Link>
              <Link href="#careers" onClick={onHowItWorksClick || goHome} style={{ color: 'rgba(255,255,255,0.8)', textDecoration: 'none', fontSize: isMobile ? '13px' : '14px' }}>
                How it works
              </Link>
              <Link href="#/contact" onClick={goContact} style={{ color: 'rgba(255,255,255,0.8)', textDecoration: 'none', fontSize: isMobile ? '13px' : '14px' }}>
                Contact
              </Link>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              variant="h6"
              style={{
                color: 'white',
                marginBottom: '20px',
                fontFamily: '"DM Sans", sans-serif',
                fontWeight: 'bold',
                fontSize: isMobile ? '16px' : '18px',
                textAlign: isMobile ? 'center' : 'left',
              }}
            >
              Support
            </Typography>
            <Box
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                alignItems: isMobile ? 'center' : 'flex-start',
              }}
            >
              <Link href="#/contact" onClick={goContact} style={{ color: 'rgba(255,255,255,0.8)', textDecoration: 'none', fontSize: isMobile ? '13px' : '14px' }}>
                Help Center
              </Link>
              <Link href="#faq" style={{ color: 'rgba(255,255,255,0.8)', textDecoration: 'none', fontSize: isMobile ? '13px' : '14px' }}>
                FAQs
              </Link>
              <Link href="javascript:void(0)" onClick={onPrivacyPolicy || defaultPrivacy} style={{ color: 'rgba(255,255,255,0.8)', textDecoration: 'none', fontSize: isMobile ? '13px' : '14px' }}>
                Privacy Policy
              </Link>
              <Link href="javascript:void(0)" onClick={onTermsConditions || defaultTerms} style={{ color: 'rgba(255,255,255,0.8)', textDecoration: 'none', fontSize: isMobile ? '13px' : '14px' }}>
                Terms of Service
              </Link>
              <Link href="javascript:void(0)" onClick={onRefundPolicy || defaultRefund} style={{ color: 'rgba(255,255,255,0.8)', textDecoration: 'none', fontSize: isMobile ? '13px' : '14px' }}>
                Refund & Cancellation Policy
              </Link>
            </Box>
          </Grid>
        </Grid>
        <Box
          style={{
            borderTop: '1px solid rgba(255,255,255,0.2)',
            marginTop: isMobile ? '30px' : '40px',
            paddingTop: '20px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            flexDirection: isMobile ? 'column' : 'row',
            gap: isMobile ? '15px' : '0',
            textAlign: isMobile ? 'center' : 'left',
          }}
        >
          <Typography variant="body2" style={{ color: 'rgba(255,255,255,0.7)', fontSize: isMobile ? '12px' : '14px' }}>
            © 2023{' '}
            <Link href="https://srshta.com/" target="_blank" rel="noopener noreferrer" style={{ color: 'rgba(255,255,255,0.9)', textDecoration: 'none', fontWeight: 600 }}>
              Srshta Tech Solutions Pvt
            </Link>
            . All rights reserved.
          </Typography>
          <Box style={{ display: 'flex', gap: isMobile ? '15px' : '20px', flexWrap: 'wrap', justifyContent: isMobile ? 'center' : 'flex-end' }}>
            <Link href="javascript:void(0)" onClick={onPrivacyPolicy || defaultPrivacy} style={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', fontSize: isMobile ? '11px' : '12px' }}>
              Privacy
            </Link>
            <Link href="javascript:void(0)" onClick={onTermsConditions || defaultTerms} style={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', fontSize: isMobile ? '11px' : '12px' }}>
              Terms
            </Link>
            <Link href="javascript:void(0)" onClick={onRefundPolicy || defaultRefund} style={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', fontSize: isMobile ? '11px' : '12px' }}>
              Refund Policy
            </Link>
            <Link href="#cookies" style={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', fontSize: isMobile ? '11px' : '12px' }}>
              Cookies
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
